import api from "src/utils/api";

const unwrap = (data) =>
  data && Array.isArray(data.results) ? data.results : data;

export const workforceApi = {
  getDashboard: () => api.get("workforce/dashboard/").then((r) => r.data),
  getAgents: () => api.get("workforce/agents/").then((r) => unwrap(r.data)),
  getCatalog: () =>
    api.get("workforce/agents/catalog/").then((r) => unwrap(r.data)),
  getActivities: () =>
    api.get("workforce/activities/").then((r) => unwrap(r.data)),

  // Team management
  activateAgent: (code, config = {}) =>
    api
      .post("workforce/agents/", { definition_code: code, config })
      .then((r) => r.data),
  toggleAgent: (id) =>
    api.post(`workforce/agents/${id}/toggle/`).then((r) => r.data),
  removeAgent: (id) =>
    api.delete(`/workforceagents/${id}/`).then((r) => r.data),

  approveActivity: (id) =>
    api.post(`workforce/activities/${id}/approve/`).then((r) => r.data),

  // Used by the detail/inbox/data-hub pages (built next).
  getAgentOutputs: (id) =>
    api.get(`workforce/agents/${id}/outputs/`).then((r) => r.data),
  getAgentActivities: (id) =>
    api.get(`workforce/agents/${id}/activities/`).then((r) => unwrap(r.data)),
  getAgentGoals: (id) =>
    api.get(`workforce/agents/${id}/goals/`).then((r) => unwrap(r.data)),
  getLeads: (params) =>
    api.get("workforce/leads/", { params }).then((r) => unwrap(r.data)),
  getLeadFacets: () => api.get("/leads/facets/").then((r) => r.data),
};

export default workforceApi;
